import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

export const AnalyticsHeaderRow = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  paddingTop: '25px',
});

export const AnalyticsTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.custom['black-10'],
  fontFeatureSettings: `'liga' off, 'clig' off`,
  fontFamily: 'Inter, sans-serif',
  fontSize: '22px',
  fontStyle: 'normal',
  fontWeight: 700,
  lineHeight: '32px',
  letterSpacing: '-0.22px',
}));
